(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vedica-policy-centre"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.vpcReady==='true')return;
    root.dataset.vpcReady='true';

    const source=root.querySelector('[data-vpc-source]');
    const toc=root.querySelector('[data-vpc-toc]');
    const search=root.querySelector('[data-vpc-search]');
    const status=root.querySelector('[data-vpc-search-status]');
    const noResults=root.querySelector('[data-vpc-no-results]');
    const progress=root.querySelector('[data-vpc-progress]');
    const topButton=root.querySelector('[data-vpc-top]');
    const scopeButtons=Array.from(root.querySelectorAll('[data-vpc-scope]'));
    const hasShippingScope=root.dataset.policy==='shipping'&&scopeButtons.length>0;
    let currentShippingScope='domestic';
    let revealObserver=null;
    let activeTocObserver=null;

    const slugify=(value)=>String(value||'').toLowerCase().trim().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');

    function buildCards(){
      if(!source)return;
      const nodes=Array.from(source.childNodes);
      if(!nodes.length)return;
      const fragment=document.createDocumentFragment();
      let current=null;
      let intro=null;
      let sectionIndex=0;
      let currentScope=hasShippingScope?'domestic':'all';

      function makeCard(heading){
        sectionIndex+=1;
        const title=(heading.textContent||'').trim()||('Section '+sectionIndex);
        const card=document.createElement('article');
        card.className='vpc-card';
        card.setAttribute('data-vpc-card','');
        card.dataset.title=title;
        if(hasShippingScope)card.dataset.vpcScope=currentScope;
        card.id='policy-'+(hasShippingScope?currentScope+'-':'')+slugify(title)+'-'+sectionIndex;

        const head=document.createElement('div');
        head.className='vpc-card__head';
        const number=document.createElement('span');
        number.className='vpc-card__number';
        number.textContent=currentScope==='shared'?'♡':String(sectionIndex).padStart(2,'0');
        const text=document.createElement('div');
        const small=document.createElement('small');
        small.textContent='POLICY POINT';
        const h2=document.createElement('h2');
        h2.innerHTML=heading.innerHTML;
        const style=heading.getAttribute('style');
        if(style)h2.setAttribute('style',style);
        text.appendChild(small);text.appendChild(h2);
        const anchor=document.createElement('button');
        anchor.type='button';anchor.className='vpc-card__anchor';anchor.setAttribute('aria-label','Copy link to '+title);anchor.textContent='#';
        anchor.addEventListener('click',async()=>{
          const url=window.location.origin+window.location.pathname+window.location.search+'#'+card.id;
          try{await navigator.clipboard.writeText(url);anchor.textContent='✓';setTimeout(()=>anchor.textContent='#',1000);}catch(e){window.location.hash=card.id;}
        });
        head.appendChild(number);head.appendChild(text);head.appendChild(anchor);
        const body=document.createElement('div');
        body.className='vpc-card__content rte';
        card.appendChild(head);card.appendChild(body);fragment.appendChild(card);
        return {card,body};
      }

      nodes.forEach((node)=>{
        if(hasShippingScope&&node.nodeType===1&&node.hasAttribute('data-vpc-scope-start')){
          const nextScope=node.getAttribute('data-vpc-scope-start');
          if(nextScope==='domestic'||nextScope==='international'||nextScope==='shared')currentScope=nextScope;
          current=null;
          intro=null;
          sectionIndex=0;
          return;
        }
        if(node.nodeType===1&&node.tagName==='H2'){
          current=makeCard(node);return;
        }
        if(!current){
          const meaningful=node.nodeType!==3||String(node.textContent||'').trim();
          if(!meaningful)return;
          if(!intro){
            const heading=document.createElement('h2');heading.textContent='Overview';
            intro=makeCard(heading);
          }
          intro.body.appendChild(node);
        }else current.body.appendChild(node);
      });

      source.innerHTML='';source.appendChild(fragment);
    }

    function cards(){return Array.from(root.querySelectorAll('[data-vpc-card]'));}
    function visibleCards(){return cards().filter(card=>!card.hidden);}

    function buildToc(){
      if(!toc)return;
      toc.innerHTML='';
      visibleCards().forEach(card=>{
        const a=document.createElement('a');
        a.href='#'+card.id;a.textContent=card.dataset.title||'Section';
        a.addEventListener('click',(e)=>{e.preventDefault();card.scrollIntoView({behavior:'smooth',block:'start'});history.replaceState(null,'','#'+card.id);});
        toc.appendChild(a);
      });
    }

    function setupReveal(){
      const list=visibleCards();
      if(revealObserver)revealObserver.disconnect();
      if(!('IntersectionObserver'in window)){list.forEach(c=>c.classList.add('is-visible'));return;}
      revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}}),{rootMargin:'0px 0px -7% 0px',threshold:.08});
      list.forEach(c=>revealObserver.observe(c));
    }

    function setupActiveToc(){
      if(activeTocObserver)activeTocObserver.disconnect();
      if(!toc||!('IntersectionObserver'in window))return;
      const links=Array.from(toc.querySelectorAll('a'));
      activeTocObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;links.forEach(a=>a.classList.toggle('is-active',a.getAttribute('href')==='#'+entry.target.id));}),{rootMargin:'-22% 0px -66% 0px'});
      visibleCards().forEach(c=>activeTocObserver.observe(c));
    }

    function setupSpotlight(){
      cards().forEach(card=>{
        card.addEventListener('pointermove',(e)=>{const r=card.getBoundingClientRect();card.style.setProperty('--mx',(e.clientX-r.left)+'px');card.style.setProperty('--my',(e.clientY-r.top)+'px');});
      });
    }

    function setupSearch(){
      if(!search)return;
      const normalize=v=>String(v||'').toLowerCase().replace(/\s+/g,' ').trim();
      const apply=()=>{
        const q=normalize(search.value);let visible=0;
        cards().forEach(card=>{
          const inScope=!hasShippingScope||card.dataset.vpcScope===currentShippingScope||card.dataset.vpcScope==='shared';
          const match=inScope&&(!q||normalize(card.textContent).includes(q));
          card.hidden=!match;if(match)visible+=1;
        });
        if(status){status.hidden=!q;status.textContent=q?`${visible} section${visible===1?'':'s'} matching “${search.value.trim()}”`:'';}
        if(noResults)noResults.hidden=visible!==0;
      };
      search.addEventListener('input',apply);
      document.addEventListener('keydown',(e)=>{
        if(e.key==='/'&&!/input|textarea|select/i.test(document.activeElement&&document.activeElement.tagName||'')){e.preventDefault();search.focus();}
        if(e.key==='Escape'&&document.activeElement===search){search.value='';apply();search.blur();}
      });
    }


    function setupShippingScope(){
      if(!hasShippingScope)return;

      const requested=new URL(window.location.href).searchParams.get('scope');
      currentShippingScope=requested==='international'?'international':'domestic';

      const hashTarget=window.location.hash?root.querySelector(window.location.hash):null;
      if(hashTarget&&hashTarget.dataset.vpcScope&&hashTarget.dataset.vpcScope!=='shared')currentShippingScope=hashTarget.dataset.vpcScope;

      const applyScope=(scope,{updateUrl=true,scroll=false}={})=>{
        currentShippingScope=scope==='international'?'international':'domestic';
        root.dataset.shippingScope=currentShippingScope;

        scopeButtons.forEach((button)=>{
          const active=button.dataset.vpcScope===currentShippingScope;
          button.classList.toggle('is-active',active);
          button.setAttribute('aria-selected',active?'true':'false');
          button.tabIndex=active?0:-1;
        });

        cards().forEach((card)=>{
          card.hidden=card.dataset.vpcScope!==currentShippingScope&&card.dataset.vpcScope!=='shared';
          if(!card.hidden)card.classList.remove('is-visible');
        });

        if(search)search.value='';
        if(status){status.hidden=true;status.textContent='';}
        if(noResults)noResults.hidden=true;

        buildToc();
        setupReveal();
        setupActiveToc();
        setupReadTime();

        if(updateUrl){
          const url=new URL(window.location.href);
          if(currentShippingScope==='international')url.searchParams.set('scope','international');
          else url.searchParams.delete('scope');
          url.hash='';
          history.replaceState(null,'',url.pathname+url.search);
        }

        if(scroll){
          const target=root.querySelector('#policy-content');
          if(target)target.scrollIntoView({behavior:'smooth',block:'start'});
        }
      };

      scopeButtons.forEach((button,index)=>{
        button.addEventListener('click',()=>applyScope(button.dataset.vpcScope,{updateUrl:true,scroll:true}));
        button.addEventListener('keydown',(event)=>{
          if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))return;
          event.preventDefault();
          const delta=(event.key==='ArrowRight'||event.key==='ArrowDown')?1:-1;
          const next=(index+delta+scopeButtons.length)%scopeButtons.length;
          scopeButtons[next].focus();
          applyScope(scopeButtons[next].dataset.vpcScope,{updateUrl:true,scroll:false});
        });
      });

      applyScope(currentShippingScope,{updateUrl:false,scroll:false});
    }

    function setupReader(){
      const buttons=Array.from(root.querySelectorAll('[data-vpc-size]'));
      const allowed=['0.94','1','1.12'];
      const setScale=(value)=>{
        const scale=allowed.includes(String(value))?String(value):'1';
        root.style.setProperty('--reader',scale);
        const styles=getComputedStyle(root);
        const desktopBase=Math.max(18,parseFloat(styles.getPropertyValue('--vpc-body-size'))||19);
        const mobileBase=Math.max(16,parseFloat(styles.getPropertyValue('--vpc-mobile-size'))||17);
        root.style.setProperty('--vpc-reader-size',(desktopBase*Number(scale))+'px');
        root.style.setProperty('--vpc-reader-mobile-size',(mobileBase*Number(scale))+'px');
        buttons.forEach(b=>b.classList.toggle('is-active',b.dataset.vpcSize===scale));
        try{localStorage.setItem('vedica-policy-reader-scale',scale);}catch(e){}
      };
      let saved='1';try{saved=localStorage.getItem('vedica-policy-reader-scale')||'1';}catch(e){}
      setScale(saved);buttons.forEach(b=>b.addEventListener('click',()=>setScale(b.dataset.vpcSize)));
    }

    function setupPrintCopy(){
      root.querySelectorAll('[data-vpc-print]').forEach(b=>b.addEventListener('click',()=>window.print()));
      const copy=root.querySelector('[data-vpc-copy]');
      if(copy)copy.addEventListener('click',async()=>{const original=copy.textContent;try{await navigator.clipboard.writeText(window.location.href);copy.textContent='Link copied ✓';}catch(e){copy.textContent='Copy failed';}setTimeout(()=>copy.textContent=original,1300);});
    }

    function setupProgress(){
      const update=()=>{
        const rect=root.getBoundingClientRect();
        const total=Math.max(1,root.offsetHeight-window.innerHeight);
        const passed=Math.min(total,Math.max(0,-rect.top));
        if(progress)progress.style.width=(passed/total*100)+'%';
        if(topButton)topButton.classList.toggle('is-visible',window.scrollY>520);
      };
      update();window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});
      if(topButton)topButton.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));
    }

    function setupReadTime(){
      const label=root.querySelector('[data-vpc-read-time]');
      if(!label)return;
      const words=visibleCards().map(card=>card.innerText||'').join(' ').trim().split(/\s+/).filter(Boolean).length;
      const mins=Math.max(1,Math.round(words/220));label.textContent=`${mins} min read`;
    }

    buildCards();
    if(hasShippingScope){
      setupShippingScope();
    }else{
      buildToc();setupReveal();setupActiveToc();setupReadTime();
    }
    setupSpotlight();setupSearch();setupReader();setupPrintCopy();setupProgress();

    if(window.location.hash){
      const target=root.querySelector(window.location.hash);
      if(target){
        if(hasShippingScope&&target.dataset.vpcScope&&target.dataset.vpcScope!=='shared'&&target.dataset.vpcScope!==currentShippingScope){
          currentShippingScope=target.dataset.vpcScope;
          root.dataset.shippingScope=currentShippingScope;
          cards().forEach(card=>card.hidden=card.dataset.vpcScope!==currentShippingScope&&card.dataset.vpcScope!=='shared');
          scopeButtons.forEach(button=>{const active=button.dataset.vpcScope===currentShippingScope;button.classList.toggle('is-active',active);button.setAttribute('aria-selected',active?'true':'false');button.tabIndex=active?0:-1;});
          buildToc();setupReveal();setupActiveToc();setupReadTime();
        }
        setTimeout(()=>target.scrollIntoView({block:'start'}),80);
      }
    }
  }

  function initAll(scope){const context=scope||document;if(context.matches&&context.matches('[data-vpc]'))init(context);context.querySelectorAll&&context.querySelectorAll('[data-vpc]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll(document));else initAll(document);
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
